import styled from 'styled-components';
import Colors from 'assets/Colors';

const PageContainer = styled.div`
  width: 97%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
`;

const TopContainer = styled.div`
  display: flex;
  justify-content: space-between;
  padding-top: 17px;
  padding-right: 42px;
  padding-left: 42px;
  width: 100%;
  background: ${Colors.background_secondary};
  border - radius: 2px;
  box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.06);
  max - width: 100vw;
  margin-bottom: 32px;
  flex-wrap: wrap;
  gap: 20px;
  @media (max-width: 768px) {
    flex-direction: column;
    padding: 10px 10px;
  }
`;

const Container = styled.div`
width: 100%;
background: ${Colors.background_secondary};
border - radius: 2px;
max - width: 100vw;
`;

const ChartComponentsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 30px;
  @media (max-width: 1390px) {
    flex-direction: column;
  }
`;

const textDate = styled.div`
  font-size: 12px;
  font-weight: 500;
  color: ${Colors.text_primary};
`;
const textLight = styled.div`
  margin-top: -31px;
  font-size: 12px;
  font-weight: 300;
  color: ${Colors.text_secondary};
`;

const Title = styled.div`
  font-style: normal;
  font-weight: 300;
  font-size: 12px;
  line-height: 14px;
  display: flex;
  align-items: center;
  color: ${Colors.text_primary};
  margin-bottom: 13px;
`;

const Title2 = styled.div`
  font-style: normal;
  font-weight: 300;
  font-size: 12px;
  line-height: 14px;
  display: flex;
  align-items: center;
  color: ${Colors.text_primary};
  margin-bottom: 13px;
  @media (max-width: 1018px) {
    display: none;
  }
`;

const downloadButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
  // @media (min-width: 1280px) {
  //   display: none;
  // }
`;

export default {
  textDate,
  Container,
  textLight,
  PageContainer,
  ChartComponentsWrapper,
  TopContainer,
  Title,
  Title2,
  downloadButtonContainer,
};
